export const DEFAULT_UPSELL_CARD_IMAGE_HEIGHT = 548; // 548px is the default desktop height of the upsell card image
export const ALTERNATE_UPSELL_CARD_IMAGE_HEIGHT = 400; // 400px is the alternate desktop height of the upsell card image
